<template>
  <div>
    <HeadlineContainer headline="Topics" :breadcrumbs="[{text: 'Topics'}]"/>

    <LoadingContainer v-if="loading"/>

    <div v-else class="container">
      <ExternalList
          endpoint="/api/v2/content-topics?sort=-publish_at"
          :headlines="headlines"
          :filters="filters"
          @show="topic => $router.push(getUrl(topic))"
      >
        <template v-slot:default="{ row: topic }">
          <td class="table__ellipsis">
            <router-link :to="getUrl(topic)">
              {{ topic.attributes.name }}
            </router-link>
          </td>

          <td class="table__ellipsis">
            <router-link :to="'/portals/' + topic.attributes.portal_id">
              {{ topic.attributes.portal_name }}
            </router-link>
          </td>

          <td class="table__ellipsis">
            {{ pageViews.find(pageview => pageview.routable_id === topic.id)?.topic_render_count || 0 }}
          </td>

          <td class="table__ellipsis">
            <span v-if="topic.attributes.publish_at">
              {{ topic.attributes.publish_at | date }}
            </span>

            <span v-else>
              N/A
            </span>
          </td>
        </template>
      </ExternalList>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import ExternalList from "../../components/Panels/Lists/External.vue";
import Avatar from "../../components/Avatar.vue";
import LoadingContainer from "../../components/Layout/LoadingContainer.vue";

export default {
  components: {Avatar, ExternalList, LoadingContainer, HeadlineContainer},

  data() {
    return {
      portals: null,
      pageViews: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/portals'),
        http.post('/api/v1/reports/new-analytics', {
          metrics: [
            {name: 'topic_render_count'},
          ],
          dimensions: [
            {name: 'routable_id'},
          ]
        })
      ]).then(responses => {
        this.portals = responses[0].data.data
        this.pageViews = responses[1].data.data

        this.loading = false
      })
    },

    getUrl(topic) {
      return '/dashboards/topics/' + topic.id
    }
  },

  computed: {
    headlines() {
      return [
        {width: 7, text: 'Name'},
        {width: 7, text: 'Portal'},
        {width: 4, text: 'Page Views'},
        {width: 4, text: 'Publish Date'},
      ]
    },

    filters() {
      return [
        [
          {
            widget: 'select',
            name: 'portal_id',
            width: 20,
            nullable: true,
            placeholder: '(all portals)',
            options: this.portals.map(portal => ({value: portal.id, label: portal.attributes.name}))
          },
          {
            widget: 'submit',
            width: 4
          },
        ]
      ]
    }
  },
}
</script>
